module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "build-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("\n          1. What We Need From You\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('form', {
    staticClass: "small",
    attrs: {
      "id": "step1",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.verifyStep1(true)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step1.name),
      expression: "step1.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "company",
      "placeholder": "Company Name *",
      "required": ""
    },
    domProps: {
      "value": (_vm.step1.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.step1.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step1.email),
      expression: "step1.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Company Email *",
      "required": ""
    },
    domProps: {
      "value": (_vm.step1.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.step1.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step1.fname),
      expression: "step1.fname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "fname",
      "placeholder": "First Name *",
      "pattern": "[a-zA-Z ]+",
      "title": "Letters and spaces only.",
      "required": ""
    },
    domProps: {
      "value": (_vm.step1.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.step1.fname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step1.lname),
      expression: "step1.lname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "lname",
      "placeholder": "Last Name *",
      "pattern": "[a-zA-Z ]+",
      "title": "Letters and spaces only.",
      "required": ""
    },
    domProps: {
      "value": (_vm.step1.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.step1.lname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step1.phone),
      expression: "step1.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "name": "phone",
      "placeholder": "Phone Number *",
      "pattern": "[0-9]+",
      "title": "Numbers only.",
      "minlength": "10",
      "maxlength": "10",
      "required": ""
    },
    domProps: {
      "value": (_vm.step1.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.step1.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step1.avail),
      expression: "step1.avail"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.step1.avail = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Best time to contact *")]), _vm._v(" "), _c('option', [_vm._v("Morning")]), _vm._v(" "), _c('option', [_vm._v("Afternoon")]), _vm._v(" "), _c('option', [_vm._v("Evening")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary fluid",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Next Step")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('form', {
    staticClass: "small",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.verifyStep2($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step2.subject),
      expression: "step2.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subject",
      "placeholder": "Subject"
    },
    domProps: {
      "value": (_vm.step2.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.step2.subject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step2.message),
      expression: "step2.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.step2.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.step2.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary fluid",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Next Step")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("3. Have Any Images To Help?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "dropzone-holder"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('dropzone', {
    ref: "dZone",
    attrs: {
      "id": "myVueDropzone",
      "url": "http://webosoftware.com/static/uploads.php",
      "acceptedFileTypes": 'image/*',
      "autoProcessQueue": false,
      "maxNumberOfFiles": 1
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-mounted": _vm.test
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary fluid",
    on: {
      "click": _vm.uploadFiles
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section fp-auto-height",
    attrs: {
      "id": "footer"
    }
  }, [_c('app-footer')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n          2. What's On Your Mind?\n          "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Upload Image (Optional)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c4a165"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BuildPage.vue
// module id = 82
// module chunks = 0